import { autoinject } from 'aurelia-framework';
import { NetlogHttpClient } from 'lib/http';
import { PenDimensionPipeSegment, UpdatePenDimensionPipeSegment } from 'models/pen/PenDimensionPipeSegment';

@autoinject
export class PenDimensionPipeSegmentService {
  constructor(private client: NetlogHttpClient) {}

  async getPenDimensionPipeSegment(id: number) {
    return await this.client.get<PenDimensionPipeSegment>({
      url: `api/pen-dimension-pipe-segment/get-pen-dimension-segment/${id}`,
      model: PenDimensionPipeSegment,
    });
  }

  async getPenDimensionPipeSegments(id: number) {
    return await this.client.get<PenDimensionPipeSegment[]>({
      url: `api/pen-dimension-pipe-segment/list/${id}`,
      model: PenDimensionPipeSegment,
    });
  }

  async updatePenDimensionPipeSegment(id: number, data: UpdatePenDimensionPipeSegment) {
    return await this.client.post({
      data,
      url: `api/pen-dimension-pipe-segment/${id}`,
    });
  }

  async createPenDimensionPipeSegment(id: number, index: number) {
    return await this.client.post({
      url: `api/pen-dimension-pipe-segment/${id}/create/${index}`,
    });
  }

  async updatePenDimensionPipeSegmentStatus(id: number, statusId: number) {
    return await this.client.post({
      url: `api/pen-dimension-pipe-segment/${id}/status/${statusId}`,
    });
  }
}
